import { render, staticRenderFns } from "./ocr.vue?vue&type=template&id=65c10225&"
import script from "./ocr.vue?vue&type=script&lang=js&"
export * from "./ocr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports